
import { JartinetHomePageClient } from '@/components/jartinet/JartinetHomePageClient';
import { PeriodicoArticle, CalendarEvent } from '@/lib/types';
import { db } from '@/firebase/config';
import { collection, query, orderBy, limit, getDocs, where } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import { sanitizeFirestoreData } from '@/lib/utils';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { DiscordWidget } from '@/components/jartinet/DiscordWidget';
import { NormativaSemanaSanta } from '@/components/jartinet/NormativaSemanaSanta';
import { TiempoJartiland } from '@/components/jartinet/TiempoJartiland';

export default function JartinetPage() {
    const [upcomingEvents, setUpcomingEvents] = useState<CalendarEvent[]>([]);
    const [upcomingProcesiones, setUpcomingProcesiones] = useState<CalendarEvent[]>([]);
    const [latestArticle, setLatestArticle] = useState<PeriodicoArticle | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function getPanelData() {
            try {
                const now = new Date();
                // Se piden más eventos de los que se muestran y se separan aquí por tipo.
                // Filtrar por `tipo` en la query exigiría un índice compuesto (igualdad +
                // rango sobre campos distintos); así basta con el rango sobre `start`.
                const eventsQuery = query(collection(db, 'events'), where('start', '>=', now), orderBy('start', 'asc'), limit(50));
                const eventsSnapshot = await getDocs(eventsQuery);

                const events: CalendarEvent[] = eventsSnapshot.docs
                    .map(doc => sanitizeFirestoreData({ id: doc.id, ...doc.data() }) as CalendarEvent)
                    .map(e => ({ ...e, start: new Date(e.start), end: new Date(e.end) }));

                setUpcomingEvents(events.filter(e => e.tipo !== 'procesion').slice(0, 3));
                setUpcomingProcesiones(events.filter(e => e.tipo === 'procesion').slice(0, 4));

                const articlesQuery = query(collection(db, 'periodico_articles'), orderBy('createdAt', 'desc'), limit(1));
                const articlesSnapshot = await getDocs(articlesQuery);
                if (!articlesSnapshot.empty) {
                    const doc = articlesSnapshot.docs[0];
                    setLatestArticle(sanitizeFirestoreData({ id: doc.id, ...doc.data() }) as PeriodicoArticle);
                }

            } catch (error: any) {
                console.error("Error fetching panel data on client:", error);
                setError("No se pudieron cargar los datos del panel. Es posible que no tengas permisos para ver esta información.");
            } finally {
                setLoading(false);
            }
        }
        getPanelData();
    }, []);
    
    if (loading) {
        return (
            <div className="flex h-64 items-center justify-center">
                <Loader2 className="h-10 w-10 animate-spin" />
            </div>
        );
    }
    
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
                <JartinetHomePageClient 
                    upcomingEvents={upcomingEvents}
                    upcomingProcesiones={upcomingProcesiones}
                    latestArticle={latestArticle}
                    error={error}
                />
            </div>
            <div className="lg:col-span-1 space-y-8">
                <TiempoJartiland />
                <DiscordWidget />
                <NormativaSemanaSanta />
            </div>
        </div>
    );
}
